import { Translate } from "components/common/Translate/Translate";
import { useDimensionTypes } from "./useDimensionTypes";

export const DimensionTypes = () => {
    const { handleClick, dimensionType } = useDimensionTypes();

    return (
        <div className="cursor-pointer flex items-center gap-4 py-1 justify-between rounded-lg bg-irGray-200 dark:bg-darkSurface-200 text-slate-600 dark:text-darkSurface-600 font-semibold capitalize whitespace-nowrap px-1">
            <div
                data-testid="enlarge-by-dimensions-selector"
                className={`capitalize py-2 flex-grow text-center ${
                    dimensionType === "pixels"
                        ? `bg-white dark:bg-darkSurface-300 dark:text-white text-black rounded-lg`
                        : "text-irGray-600 dark:text-darkSurface-600"
                }`}
                onClick={() => handleClick("pixels")}
            >
                <Translate keyName="by-dimensions" />
            </div>
            <div
                data-testid={`enlarge-as-percentage-selector`}
                className={`py-2 flex-grow text-center ${
                    dimensionType === "percentage"
                        ? `bg-white dark:bg-darkSurface-300 dark:text-white text-black rounded-lg`
                        : "text-irGray-600 dark:text-darkSurface-600"
                }`}
                onClick={() => handleClick("percentage")}
            >
                <Translate keyName="as-percentage" />
            </div>
        </div>
    );
};
